import React, { FC, PropsWithChildren } from 'react';

import styles from './_ImageOverlay.module.css';

interface ImageOverlayProps {
    image: React.ReactNode;
}

export const ImageOverlay: FC<PropsWithChildren<ImageOverlayProps>> = ({ image, children }) => (
    <div className={styles.root}>
        {image}
        <div className={styles.content}>{children}</div>
    </div>
);
